import React, { useState } from "react";
import { FieldArray, FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { InquiryFormValues } from "src/models/Inquiry.model";
import AccordianFormLayout from "src/components/layouts/AccordianFormLayout/AccordianFormLayout";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";
import { AiOutlinePlus } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import useCourse from "src/hooks/useCourse";
import { handleValidNumber } from "src/utils/validations/numberInput";
import { Chip } from "@mui/material";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import useCountries from "src/hooks/useCountries";
import useCountryStates from "src/hooks/useCountryStates";
import useStateCities from "src/hooks/useStateCities";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import useInquiryLabels from "src/hooks/useInquiryLabels";
import ATMSelectValue from "src/components/UI/atoms/formFields/ATMSelectValue/ATMSelectValue";
import useDispositionLevelOne from "src/hooks/useDisPositions";
import { useGetAllDispositionLevelTwoByLevelOneIdQuery } from "src/services/DispositionLevelTwoServices";

type Props = {
  formikProps: FormikProps<InquiryFormValues>;
  onRedirect: () => void;
  setInquiredNumber: any;
};

const CommunicationOption = [
  {
    label: "VISIT",
    value: "VISIT",
  },
  {
    label: "WHATSAPP",
    value: "WHATSAPP",
  },
  {
    label: "CALL",
    value: "CALL",
  },
  {
    label: "EMAIL",
    value: "EMAIL",
  },
  {
    label: "OTHER",
    value: "OTHER",
  },
];
const inquiryTypeOptions = [
  {
    label: "INBOUND",
    value: "INBOUND",
  },
  {
    label: "OUTBOUND",
    value: "OUTBOUND",
  },
  {
    label: "VISIT",
    value: "VISIT",
  },
];
const InquiryForm = ({ formikProps, onRedirect, setInquiredNumber }: Props) => {
  const {
    values,
    setFieldValue,
    handleBlur,
    isSubmitting,
    errors,
    submitCount,
  } = formikProps;
  const [isShowScriptBtn, setIsShowScriptBtn] = useState(false); 
  const { inquiryLabels, isDataLoading: inquiryLabelsLoading } =
    useInquiryLabels();

  const { countries, isDataLoading: isCountriesLoading } = useCountries();

  //
  const { countryStates, isDataLoading: isCountryStatesLoading } =
    useCountryStates(values?.countryId?.value || "");
  //
  const { stateCities, isDataLoading: isStateCitiesLoading } = useStateCities(
    values?.stateId?.value || ""
  );

  //ALL COURSE
  const { course, isDataLoading: isCourseLoading } = useCourse();
  const CourseOption = course?.map((el: any) => {
    return {
      label: el?.courseName,
      value: el?._id,
      classroomFees: el?.classroomFees,
    };
  });
  //STATE

  //Inquiry Label Option
  const InquiryLabelOptions = inquiryLabels?.map((el: any, ind: any) => {
    return {
      label: el?.inquiryLabel,
      value: el?._id,
    };
  });

   //ALL DisPosition Level One
   const { DispositionLevelOne, isDataLoading: isDispositionLevelOneLoading } =
   useDispositionLevelOne();
 const DispositionLevelOneOption = DispositionLevelOne?.map((el: any) => {
   return {
     label: el?.dispositionFirstName,
     value: el?._id,
   };
 });
 //ALL DisPosition Level Two
 const {
   data: DispositionLevelTwoData,
   isLoading: DispositionLevelTwoDataIsLoading,
   isFetching: DispositionLevelTwoDataIsFetching,
 } = useGetAllDispositionLevelTwoByLevelOneIdQuery(values?.disposition_one, {
   skip: !values?.disposition_one,
 });
 const DispositionLevelTwoOption = DispositionLevelTwoData?.data?.map(
   (el: any) => {
     return {
       label: el?.dispositionSecondName,
       value: el?._id,
     };
   }
 );

  const handleChipClick = (value: any) => {
    if (values?.inquired_for?.includes(value as any)) {
      let newIn = [...values.inquired_for];
      let updateIn = newIn.filter(
        (selectedValue: any) => selectedValue !== value
      );
      setFieldValue("inquired_for", [...updateIn]);
    } else {
      setFieldValue("inquired_for", [...values.inquired_for, value]);
    }
  };

  return (
    <div className="p-6 flex flex-col gap-4">
      <div className="text-xl font-medium text-primary-dark">
        {" "}
        Add Inquiry Form
      </div>

      <div className="border-l-[3px] border-primary-dark px-3 py-1  font font-medium text-[18px] sticky top-0 bg-white z-[8]  text-primary-dark">
        Information
      </div>
      <div className="my-1 font-semibold text-red-500">
        {errors?.any_one_contact && submitCount > 0 && (
          <div>
            Please enter any one filed among Mobile number , Email And Other
            Social Media Id's{" "}
          </div>
        )}
      </div>

      <div className="grid grid-cols-3 gap-4">
        {/* Mobile Number */}
        <div className="">
          <ATMTextField
            name="mobile"
            value={values.mobile}
            onChange={(e) => {
              handleValidNumber(e, { forMobile: true }) &&
                setFieldValue("mobile", e.target.value);
              handleValidNumber(e, { forMobile: true }) &&
                setInquiredNumber(e.target.value);
            }}
            label="Mobile Number"
            placeholder="Enter Mobile Number"
            onBlur={handleBlur}
          />
        </div>
        {/* Name */}
        <div>
          <ATMTextField
            name="name"
            value={values.name}
            onChange={(e) => setFieldValue("name", e.target.value)}
            label="Name"
            placeholder="Enter Name"
            onBlur={handleBlur}
          />
        </div>

        {/* Email */}
        <div className="">
          <ATMTextField
            name="email"
            value={values.email}
            onChange={(e) => setFieldValue("email", e.target.value)}
            label="Email"
            placeholder="Enter Email"
            onBlur={handleBlur}
          />
        </div>
        {/*WhatsApp Mobile Number */}
        <div>
          <ATMTextField
            name="whatsApp_mobile"
            value={values.whatsApp_mobile}
            onChange={(e) =>
              handleValidNumber(e, { forMobile: true }) &&
              setFieldValue("whatsApp_mobile", e.target.value)
            }
            label="WhatsApp Number"
            placeholder="Enter WhatsApp Number"
            onBlur={handleBlur}
          />
        </div>
        {/*Alternate Number 1 */}
        <div>
          <ATMTextField
            name="alternate_number_1"
            value={values.alternate_number_1}
            onChange={(e) =>
              handleValidNumber(e, { forMobile: true }) &&
              setFieldValue("alternate_number_1", e.target.value)
            }
            label="Alternate Number 1"
            placeholder="Enter Alternate Number 1"
            onBlur={handleBlur}
          />
        </div>
        {/*Alternate Number 2 */}
        <div>
          <ATMTextField
            name="alternate_number_2"
            value={values.alternate_number_2}
            onChange={(e) =>
              handleValidNumber(e, { forMobile: true }) &&
              setFieldValue("alternate_number_2", e.target.value)
            }
            label="Alternate Number 2"
            placeholder="Enter Alternate Number"
            onBlur={handleBlur}
          />
        </div>
        {/* Inquiry Type */}
        <div className="">
          <ATMSelect
            name="inquiryType"
            value={values?.inquiryType}
            onChange={(value) => setFieldValue("inquiryType", value)}
            options={inquiryTypeOptions}
            label="Inquiry Type"
          />
        </div>
         {/* Inquiry Label */}
         <div className="">
          <ATMSelect
            name="inquiryLabel"
            value={values?.inquiryLabel}
            onChange={(value) => setFieldValue("inquiryLabel", value)}
            options={InquiryLabelOptions}
            label="Inquiry Label"
            isLoading={inquiryLabelsLoading}
          />
        </div>
      </div>
      <div className="border-l-[3px] border-primary-dark px-3 font font-medium text-[18px]  bg-white  text-primary-dark mt-1">
        Disposition Details
      </div>

      <div className="grid xl:grid-cols-3 md:grid-cols-2 gap-4 my-2">
        <div>
          <ATMSelectValue
            name="disposition_one"
            value={values?.disposition_one}
            onChange={(newValue) => {
              setFieldValue("disposition_one", newValue);
              setFieldValue("disposition_two", "");
            }}
            onBlur={handleBlur}
            label="Disposition One"
            placeholder="Select Disposition One"
            options={DispositionLevelOneOption}
            isLoading={isDispositionLevelOneLoading}
          />
        </div>
        <div>
          <ATMSelectValue
            name="disposition_two"
            value={values?.disposition_two}
            onChange={(newValue) => {
              setFieldValue("disposition_two", newValue);
            }}
            onBlur={handleBlur}
            label="Disposition Two"
            placeholder="Select Disposition Two"
            options={DispositionLevelTwoOption}
            isLoading={
              DispositionLevelTwoDataIsLoading ||
              DispositionLevelTwoDataIsFetching
            }
          />

        </div>
      
      </div> 
      <div className="border-l-[3px] border-primary-dark px-3 font font-medium text-[18px]  bg-white  text-primary-dark mt-1">
       Address
      </div>
      <div className=" grid xl:grid-cols-3 grid-cols-2 gap-4">
        {/* Country */}
        <div className="">
          <ATMSelect
            name="countryId"
            value={values.countryId}
            onChange={(newValue) => {
              setFieldValue("countryId", newValue);
              setFieldValue("stateId", "");
              setFieldValue("cityId", "");
            }}
            label="Country"
            placeholder="Select Country"
            options={countries?.map((el: any) => {
              return {
                label: el?.countryName,
                value: el?._id,
              };
            })}
            isLoading={isCountriesLoading}
            renderOption={(option, { context }) => {
              if (context === "menu") {
                return <div className="capitalize"> {option?.label} </div>;
              } else {
                return <div className="capitalize"> {option?.label} </div>;
              }
            }}
            isOptionEqualToValue={(option, selected) => {
              return option?.value === selected.value;
            }}
            isSearchedOption={(option, searchValue) => {
              return searchValue
                ? option?.data?.label?.includes(searchValue)
                : true;
            }}
          />
        </div>

        {/* State */}
        <div className="">
          <ATMSelect
            name="stateId"
            value={values.stateId}
            onChange={(newValue) => {
              setFieldValue("stateId", newValue);
              setFieldValue("cityId", "");
            }}
            label="State"
            placeholder="Select State"
            options={countryStates?.map((el: any) => {
              return {
                label: el?.stateName,
                value: el?._id,
              };
            })}
            isLoading={isCountryStatesLoading}
            renderOption={(option, { context }) => {
              if (context === "menu") {
                return <div className="capitalize"> {option?.label} </div>;
              } else {
                return <div className="capitalize"> {option?.label} </div>;
              }
            }}
            isOptionEqualToValue={(option, selected) => {
              return option?.value === selected.value;
            }}
            isSearchedOption={(option, searchValue) => {
              return searchValue
                ? option?.data?.label?.includes(searchValue)
                : true;
            }}
            disabled={!values?.countryId}
          />
        </div>

        {/* City */}
        <div className="">
          <ATMSelect
            name="cityId"
            value={values.cityId}
            onChange={(newValue) => {
              setFieldValue("cityId", newValue);
            }}
            label="City"
            placeholder="Select City"
            options={stateCities?.map((el: any) => {
              return {
                label: el?.cityName,
                value: el?._id,
              };
            })}
            isLoading={isStateCitiesLoading}
            renderOption={(option, { context }) => {
              if (context === "menu") {
                return <div className="capitalize"> {option?.label} </div>;
              } else {
                return <div className="capitalize"> {option?.label} </div>;
              }
            }}
            isOptionEqualToValue={(option, selected) => {
              return option?.value === selected.value;
            }}
            isSearchedOption={(option, searchValue) => {
              return searchValue
                ? option?.data?.label?.includes(searchValue)
                : true;
            }}
            disabled={!values?.stateId}
          />
        </div>
      </div>
      <div className="mt-3">
        <AccordianFormLayout formHeading="OTHER" isOpen={false}>
          <div className="grid grid-cols-3 gap-4 p-2">
            {/* Linkedin ID */}
            <div className="">
              <ATMTextField
                name="linkedin_id"
                value={values?.linkedin_id}
                onChange={(e) => setFieldValue("linkedin_id", e.target.value)}
                label="Linkedin ID"
                placeholder="Enter Linkedin ID"
                onBlur={handleBlur}
              />
            </div>
            {/* Twitter ID */}
            <div className="">
              <ATMTextField
                name="twitter_id"
                value={values?.twitter_id}
                onChange={(e) => setFieldValue("twitter_id", e.target.value)}
                label="Twitter ID"
                placeholder="Enter Twitter ID"
                onBlur={handleBlur}
              />
            </div>
            {/* Instagram ID */}
            <div>
              <ATMTextField
                name="instagram_id"
                value={values.instagram_id}
                onChange={(e) => setFieldValue("instagram_id", e.target.value)}
                label="Instagram ID"
                placeholder="Enter Instagram ID"
                onBlur={handleBlur}
              />
            </div>
            {/* Facebook ID */}
            <div className="">
              <ATMTextField
                name="facebook_id"
                value={values.facebook_id}
                onChange={(e) => setFieldValue("facebook_id", e.target.value)}
                label="Facebook ID"
                placeholder="Enter Facebook ID"
                onBlur={handleBlur}
              />
            </div>
            {/* Youtube ID */}
            <div className="">
              <ATMTextField
                name="youtube_id"
                value={values.youtube_id}
                onChange={(e) => setFieldValue("youtube_id", e.target.value)}
                label="Youtube ID"
                placeholder="Enter Youtube ID"
                onBlur={handleBlur}
              />
            </div>
          </div>
        </AccordianFormLayout>
      </div>
      <div>
        <div className="border-l-[3px] border-primary-dark px-3 py-1   font font-medium text-[18px] sticky top-0 bg-white  text-primary-dark">
          In Interested Course :
        </div>
        <div className="flex mt-4 gap-2 items-center">
          <ATMCheckbox
            extraClasses="font-semibold"
            checked={isShowScriptBtn}
            onChange={(newValue) => {
              setIsShowScriptBtn(newValue);
              newValue === true
                ? setFieldValue("interested_course", [])
                : setFieldValue("interested_course", [
                    {
                      course_name: "",
                      fees: "",
                      Offer_Price: "",
                      remark: "",
                    },
                  ]);
            }}
            label="Not Clear"
          ></ATMCheckbox>
          {isShowScriptBtn && (
            <ATMLoadingButton className="w-[130px]  bg-blue-400" type="button">
              <a
                href={
                  "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
                }
                target="_blank"
                rel="noreferrer"
                className="text-link border-b border-link mr-3"
              >
                {" "}
                Open Script{" "}
              </a>
            </ATMLoadingButton>
          )}
        </div>
        <div className="mt-1">
          <FieldArray
            name="interested_course"
            render={({ push, remove }) => (
              <>
                {values?.interested_course?.map((doc, index) => {
                  return (
                    <div key={index}>
                      <div className="flex justify-end mt-3">
                        <MdDelete
                          color="#F70913"
                          size={30}
                          className="pl-1 cursor-pointer"
                          onClick={() => {
                            showConfirmationDialog({
                              title: "Heads Up",
                              text: "Are you sure want to Delete this Course?",
                              icon: "question",
                              showCancelButton: true,
                              next: (result) => {
                                if (result.isConfirmed) {
                                  remove(index);
                                }
                              },
                            });
                          }}
                        />
                      </div>
                      <div className="grid xl:grid-cols-4 md:grid-cols-2 gap-6">
                        <div>
                          <ATMSelect
                            name={`interested_course[${index}].course_name`}
                            value={
                              values?.interested_course?.[index]?.course_name
                            }
                            onChange={(e) => {
                              setFieldValue(
                                `interested_course[${index}].course_name`,
                                e
                              );
                              setFieldValue(
                                `interested_course[${index}].fees`,
                                e?.classroomFees
                              );
                            }}
                            options={CourseOption}
                            label="Course Name"
                            isLoading={isCourseLoading}
                          />
                        </div>
                        <div>
                          <ATMTextField
                            name={`interested_course[${index}].fees`}
                            value={values?.interested_course?.[index]?.fees}
                            onChange={(e) =>
                              handleValidNumber(e) &&
                              setFieldValue(
                                `interested_course[${index}].fees`,
                                e.target.value
                              )
                            }
                            label="Total Fees"
                            placeholder="Enter Total Fees"
                            onBlur={handleBlur}
                          />
                        </div>
                        <div>
                          <ATMTextField
                            name={`interested_course[${index}].Offer_Price`}
                            value={
                              values?.interested_course?.[index]?.Offer_Price
                            }
                            onChange={(e) =>
                              handleValidNumber(e) &&
                              setFieldValue(
                                `interested_course[${index}].Offer_Price`,
                                e.target.value
                              )
                            }
                            label="Offer Price"
                            placeholder="Enter Offer Price"
                            onBlur={handleBlur}
                          />
                        </div>
                        <div>
                          <ATMTextField
                            name={`interested_course[${index}].remark`}
                            value={values?.interested_course?.[index]?.remark}
                            onChange={(e) =>
                              setFieldValue(
                                `interested_course[${index}].remark`,
                                e.target.value
                              )
                            }
                            label="Remark"
                            placeholder="Enter Remark"
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div className="flex justify-end my-4">
                  <p
                    className="text-link font-semibold text-base text-[16px] max-[1024px]:text-sm flex items-center cursor-pointer"
                    onClick={() =>
                      push({
                        course_name: "",
                        fees: "",
                        Offer_Price: "",
                        remark: "",
                      })
                    }
                  >
                    <AiOutlinePlus size={18} color="#0064C4" className="mr-2" />
                    Add Course
                  </p>
                </div>
              </>
            )}
          />
        </div>
      </div>
      <div>
        <div className="border-l-[3px] border-primary-dark px-3 py-1   font font-medium text-[18px] sticky top-0 bg-white  text-primary-dark">
          Communication :
        </div>
        {/* Communication Type */}

        <div className="grid xl:grid-cols-4 grid-cols-2 mt-2 gap-6">
          <ATMSelect
            name="communication_type"
            value={values?.communication_type}
            onChange={(value) => setFieldValue("communication_type", value)}
            options={CommunicationOption}
            label="Communication Type"
          />
          {/* Communication Remark */}
          <div>
            <ATMTextField
              name="communication_remark"
              value={values.communication_remark}
              onChange={(e) =>
                setFieldValue("communication_remark", e.target.value)
              }
              label="Communication Remark"
              placeholder="Enter Communication Remark"
              onBlur={handleBlur}
            />
          </div>
        </div>
        <div className="mt-6">
          <ATMTextArea
            name={`communication_summary`}
            value={values?.communication_summary}
            onChange={(e) => setFieldValue(`communication_summary`, e)}
            label="Communication Summary"
            placeholder="Enter Communication Summary"
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div className="mt-3">
        <div className="border-l-[3px] border-primary-dark px-3 py-1   font font-medium text-[18px] sticky top-0 bg-white  text-primary-dark">
          Preferred Mode
        </div>
        <div className="grid xl:grid-cols-9 md:grid-cols-4 grid-cols-1 mt-3 gap-6">
          <Chip
            className="text-[16px]"
            color={`${
              values.inquired_for.includes("ONLINE") ? "primary" : "default"
            }`}
            label="Online"
            onClick={() => {
              handleChipClick("ONLINE");
            }}
          />
          <Chip
            className="text-[16px]"
            color={`${
              values.inquired_for.includes("CLASSROOM") ? "primary" : "default"
            }`}
            label="Classroom"
            onClick={() => {
              handleChipClick("CLASSROOM");
            }}
          />
          <Chip
            className="text-[16px]"
            color={`${
              values.inquired_for.includes("RECORDED") ? "primary" : "default"
            }`}
            label="Recorded"
            onClick={() => {
              handleChipClick("RECORDED");
            }}
          />
        </div>
      </div>
      <div className="flex justify-end">
        <div className="flex justify-end gap-2">
          <ATMLoadingButton
            isLoading={isSubmitting}
            className="min-w-[80px]"
            type="submit"
          >
            Save
          </ATMLoadingButton>
          <ATMLoadingButton
            className="min-w-[150px]"
            isLoading={isSubmitting}
            type="submit"
            onClick={() => onRedirect()}
          >
            Save & Next
          </ATMLoadingButton>
        </div>
      </div>
    </div>
  );
};

export default InquiryForm;
